var Table = (function() {
    'use strict'

    var init = function() {

        function checkSymbol() {
            if (typeof Symbol == "undefined") return false;
            return true;
        }

        if (checkSymbol()) {
            var tables = document.querySelectorAll("table");

            if(tables.length > 0) {
                for (var table of tables) {
                    var ths = [];
                    var headers = table.querySelectorAll("th");
                    var tablebody = table.querySelector("tbody");
                    var rows = tablebody.rows;

                    var i = 0;
                    var j = 0;
                    var k = 0;
                    var row;
                    var col;

                    for(i; i < headers.length; i++) {
                        ths.push(headers[i].textContent.replace(/\r?\n|\r/,"").trim());
                    }

                    for (j, row; row = rows[j]; j++) {
                        for (k = 0, col; col = row.cells[k]; k++) {
                            col.setAttribute("data-th", ths[k]);
                        }
                    }
                }
            }
        }

    }

    return {
        init: init,
    }

})();
